import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const DATE_ONLY = 'M-D-YY';
const DATETIME_UTC_24H = 'M-D-YY HH:mm';
const DATETIME_LOCAL_12H = 'M-D-YY h:mm A';

export const PICKER_DATE_FORMAT = 'M-d-yy';

const getFormattedDateUTC = (value: Date | string | null | undefined): string => {
  if (!value) return '';
  const d = dayjs.utc(value);
  return d.isValid() ? d.format(DATE_ONLY) : value.toString();
};

const getFormattedDateTimeUTC = (value: Date | string | null | undefined): string => {
  if (!value) return '';
  const d = dayjs.utc(value);
  return d.isValid() ? d.format(DATETIME_UTC_24H) : value.toString();
};

const getFormattedDateTimeLocal = (value: Date | string | null | undefined): string => {
  if (!value) return '';
  const d = dayjs(value);
  return d.isValid() ? d.format(DATETIME_LOCAL_12H) : value.toString();
};

const getFormattedDateLocal = (value: Date | string | null | undefined): string => {
  if (!value) return '';
  const d = dayjs(value);
  return d.isValid() ? d.format(DATE_ONLY) : value.toString();
};

const getMinsAgo = (value: Date | string | null | undefined): string => {
  if (!value) return '';
  const ms = Date.now() - new Date(value).getTime();
  const mins = Math.floor(ms / 60000);
  return mins < 1 ? '< 1 min ago' : `${mins} min${mins === 1 ? '' : 's'} ago`;
};

const parseDateForPicker = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = dayjs(value);
  return d.isValid() ? dayjs(d.format('YYYY-MM-DD') + 'T00:00:00').toDate() : null;
};

const formatDateForStorage = (value: Date | null | undefined): string => {
  if (!value) return '';
  return dayjs(value).format('YYYY-MM-DD');
};

export { getFormattedDateUTC, getFormattedDateTimeUTC, getFormattedDateTimeLocal, getFormattedDateLocal, getMinsAgo, parseDateForPicker, formatDateForStorage };
